import React, { useState } from 'react';
import { Button, Tabs } from 'antd';
import '../components/MyPhotos/myPhotos.css'
import PhotoAlbum from '../components/MyPhotos/PhotoAlbum';
import { Radio, Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { changePrivacy } from '../Redux/features/User/userSlice';
import { useCookies } from 'react-cookie'

const { TabPane } = Tabs;

const MyPhotos = () => {
    const dispatch = useDispatch()
    const { user } = useSelector(state => state.user)
    const [photoVisibility, setPhotoVisibility] = useState(user?.privacy?.photo)
    // eslint-disable-next-line no-unused-vars
    const [cookies, setCookie, removeCookie] = useCookies(['x-auth-token']);
    let data = {
        header: cookies['x-auth-token'],
    }

    const handlePrivacy = () => {
        dispatch(changePrivacy({...data, photo: photoVisibility}))
    }

    return (
        <div className='container myPhotos '>
            <div className='row'>
                <div className='pageHeading'>My photos</div>
                <Tabs className='backgroundLight' defaultActiveKey="1" style={{ marginLeft: 20 }}>
                    <TabPane tab="Photo Album" key="1">
                        <PhotoAlbum user={user} />
                    </TabPane>
                    <TabPane tab="Settings" key="2">
                        <div className='optHead'>
                            Choose Display Option
                        </div>
                        <Radio.Group onChange={(e)=>setPhotoVisibility(e.target.value)} value={photoVisibility}>
                            <Space direction="vertical">
                                <Radio value="show">Visible to all</Radio>
                                <Radio value="premium">Visible to all Premium Members</Radio>
                                <Radio value="likeAndPremium">Visible to Members I like and to all Premium Members</Radio>
                                <Radio value="like">Only Visible to Members I like</Radio>
                                <Radio value="hide">Don't Show to Anyone</Radio>
                            </Space>
                        </Radio.Group>

                        <div style={{ marginBottom: 30 }}>
                            <Button onClick={handlePrivacy} style={{ marginTop: 20 }}>Save My Settings</Button>
                        </div>
                    </TabPane>
                </Tabs>

            </div>
        </div>
    );
};

export default MyPhotos;
